/** No credentials: only a durable instruction not to resurrect a signed-out cookie. */
export const SESSION_INTENT_KEY = 'relaii:session-intent:v1'
export type SessionIntent = 'pending-logout' | 'signed-out' | null
let memoryIntent: SessionIntent = null

export function sessionIntent(): SessionIntent {
  try {
    const value = localStorage.getItem(SESSION_INTENT_KEY)
    memoryIntent = value === 'pending-logout' || value === 'signed-out' ? value : null
    return memoryIntent
  } catch {
    return memoryIntent
  }
}

export function setSessionIntent(value: SessionIntent): void {
  memoryIntent = value
  try {
    if (value === null) localStorage.removeItem(SESSION_INTENT_KEY)
    else localStorage.setItem(SESSION_INTENT_KEY, value)
  } catch {
    // Private/storage-disabled environments still sign out in this tab.
  }
}
